module.exports = __webpack_public_path__ + "img/plus.ff3bb74e.svg";